import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles({
  container: {
    margin: '0 14px 16px 14px',
  },
})
